import MultiSelect from '@components/MultiSelect';

import { FieldRendererProps } from '../types';

const MultiSelectField = ({ field }: FieldRendererProps) => {
  const options =
    field.options?.map((opt) => ({
      value: opt.value,
      label: opt.label,
    })) || [];

  return (
    <MultiSelect
      name={field.name}
      placeholder={field.placeholder || field.label}
      options={options}
      required={field.is_required}
      isMulti
    />
  );
};

export default MultiSelectField;
